var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { getMonth, getYear } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import './react-datepicker-sh.css';
import { Box, Flex, Icon, IconButton, Spacer, Text } from 'shared/components/ui';
import { ChevronLeft, ChevronRight } from 'shared/assets/icons';
import { CalendarIconInput, DatePickerBox, RenderDayContents, WeekdayLabel } from './components';
/**
 *  The basic Calendar component that can accept any children and styling props
 *
 * @returns {React.ReactNode}
 */
var setDateWrapper = function (newDate, setFunc) {
    setFunc(newDate === null ? new Date() : newDate);
};
export var DatePicker = function (_a) {
    var defaultDate = _a.defaultDate, minDate = _a.minDate, maxDate = _a.maxDate, _b = _a.placeholderText, placeholderText = _b === void 0 ? 'Select' : _b, onChange = _a.onChange, onBlur = _a.onBlur, reactDatePickerProps = __rest(_a, ["defaultDate", "minDate", "maxDate", "placeholderText", "onChange", "onBlur"]);
    var _c = useState(defaultDate !== null && defaultDate !== void 0 ? defaultDate : null), startDate = _c[0], setStartDate = _c[1];
    var months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    useEffect(function () {
        if (onChange) {
            onChange(startDate);
        }
    }, [onChange, startDate]);
    var onSelect = function (date) {
        setDateWrapper(date, setStartDate);
        if (onBlur) {
            onBlur(null);
        }
    };
    return (_jsx(ReactDatePicker, __assign({ dateFormat: "iii MMM d, yyyy", selected: startDate, shouldCloseOnSelect: true, showPopperArrow: false, customInput: _jsx(CalendarIconInput, {}), renderDayContents: RenderDayContents, calendarContainer: DatePickerBox, formatWeekDay: WeekdayLabel, minDate: minDate, maxDate: maxDate, placeholderText: placeholderText, renderCustomHeader: function (_a) {
            var date = _a.date, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, changeMonth = _a.changeMonth, changeYear = _a.changeYear, prevMonthButtonDisabled = _a.prevMonthButtonDisabled, nextMonthButtonDisabled = _a.nextMonthButtonDisabled;
            return (_jsxs(Flex, __assign({ m: "16px", justify: "left" }, { children: [_jsxs(Text, __assign({ as: "span", textColor: "gray.700", fontSize: "18px", fontWeight: 600 }, { children: [months[getMonth(date)], " ", getYear(date)] })), _jsx(Spacer, {}), _jsxs(Box, { children: [_jsx(IconButton, { variant: "unstyled", "aria-label": "Decrease Month", onClick: decreaseMonth, disabled: prevMonthButtonDisabled, icon: _jsx(Icon, { boxSize: 3, as: ChevronLeft }), size: "sm", colorScheme: "whiteAlpha" }), _jsx(IconButton, { variant: "unstyled", "aria-label": "Increase Month", onClick: increaseMonth, disabled: nextMonthButtonDisabled, icon: _jsx(Icon, { boxSize: 3, as: ChevronRight }), size: "sm", colorScheme: "whiteAlpha" })] }), _jsx(Box, __assign({ pl: "8px", onClick: function () {
                            var today = new Date();
                            changeMonth(getMonth(today));
                            changeYear(getYear(today));
                        } }, { children: _jsx(Text, __assign({ className: "todayButton", as: "span", textColor: "blue.500", fontSize: "16px", fontWeight: 600 }, { children: "Today" })) }))] })));
        }, onSelect: onSelect, onChange: function (date) { return setDateWrapper(date, setStartDate); }, onBlur: onBlur }, reactDatePickerProps)));
};
